export const commonEs = {
  common: {
    save: "Guardar",
    cancel: "Cancelar",
    download: "Descargar",
    loading: "Cargando...",
    goBack: "Volver",
    selectParcel: "Seleccionar parcela",
    noData: "Sin datos disponibles",
    error: "Error",
    success: "Éxito",
    generate: "Generar",
    update: "Actualizar",
    configuration: "Configuración",
    search: "Buscar",
    filter: "Filtrar",
    export: "Exportar",
    import: "Importar",
    delete: "Eliminar",
    edit: "Editar",
    view: "Ver",
    add: "Añadir",
    close: "Cerrar",
    confirm: "Confirmar",
    yes: "Sí",
    no: "No",
    hectares: "ha",
    area: "Superficie",
    date: "Fecha",
    status: "Estado",
    actions: "Acciones",
    details: "Detalles",
    all: "Todos",
    active: "Activo",
    inactive: "Inactivo",
    total: "Total",
    average: "Promedio",
    signedOut: "Sesión cerrada",
    signedOutDesc: "Has cerrado sesión correctamente",
    signOutError: "Error al cerrar sesión"
  },
  nav: {
    home: "Inicio",
    dashboard: "Panel",
    parcels: "Parcelas",
    frostProtection: "Protección Heladas",
    settings: "Ajustes",
    logout: "Cerrar Sesión",
    signIn: "Iniciar Sesión",
    signUp: "Registrarse",
    signOut: "Cerrar Sesión",
    getStarted: "Comenzar",
    features: "Características",
    pricing: "Precios",
    about: "Nosotros",
    contact: "Contacto",
    solutions: "Soluciones",
    blog: "Blog",
    insuranceCompany: "Aseguradora",
    installApp: "Instalar App",
    bookDemo: "Solicitar demo"
  },
  sidebar: {
    myFarm: "MI GRANJA",
    cooperative: "COOPERATIVA",
    summary: "RESUMEN",
    management: "GESTIÓN",
    toolsAndAnalytics: "HERRAMIENTAS Y ANÁLISIS",
    satelliteImages: "IMÁGENES SATÉLITE",
    irrigationFertilization: "RIEGO Y FERTILIZACIÓN",
    analyticsReports: "ANÁLISIS E INFORMES",
    marketIntelligence: "INTELIGENCIA DE MERCADO",
    academicTools: "HERRAMIENTAS ACADÉMICAS",
    dashboard: "PANEL",
    overview: "Resumen",
    alerts: "Alertas",
    fireDetection: "Detección de Incendios",
    calendar: "Calendario",
    seasons: "Temporadas",
    performanceRankings: "Rankings de Rendimiento",
    members: "Miembros",
    myParcels: "MIS PARCELAS",
    manageParcels: "Gestionar Parcelas",
    fieldNotebook: "Cuaderno de Campo",
    cropResources: "Recursos de Cultivo",
    viewImages: "Ver Imágenes",
    vegetationIndices: "Índices de Vegetación",
    advancedAnalysis: "Herramientas agronómicas",
    splitView: "Vista Dividida",
    ndviZones: "Zonas NDVI",
    irrigation: "Riego",
    pkOptimizer: "Optimizador P&K",
    pestsDiseases: "Plagas y Enfermedades",
    nitrogenOptimizer: "Optimizador de Nitrógeno",
    satelliteIntelligence: "Inteligencia Satelital",
    soilFertility: "Suelo y Fertilidad",
    irrigationWater: "Riego y Agua",
    irrigationOptimizer: "Optimizador de Riego",
    riskAlerts: "Riesgos y Alertas",
    reportsEvidence: "Informes y Evidencia",
    resources: "Recursos",
    parcelsGroup: "Parcelas",
    brandTagline: "Plataforma de inteligencia agrícola",
    basicAnalytics: "Análisis Básico",
    aiInsights: "Insights IA",
    intelligentFarming: "Agricultura Inteligente",
    riskAnalysisMl: "Análisis de Riesgo ML",
    reportsCenter: "Centro de Informes",
    verifiedFarm: "Granja Verificada",
    insurance: "Seguros",
    marketplace: "Mercado",
    marketPrices: "Precios de Mercado",
    priceTrends: "Tendencias de Precios",
    regionalAnalysis: "Análisis Regional",
    marketAnalytics: "Análisis de Mercado",
    commerce: "COMERCIO",
    productMarketplace: "Mercado de Productos",
    prefinancing: "Prefinanciación y Factoring",
    creditScoring: "Scoring Crediticio",
    parametricInsurance: "Seguro Paramétrico",
    certifiedMarketplace: "Mercado Certificado",
    userManual: "Manual de Usuario",
    irrigationReports: "Informes de Riego",
    copernicusData: "Datos Copernicus",
    groundTruthValidation: "Observaciones de Campo",
    phenology: "Inteligencia fenológica",
    supportTickets: "Tickets de Soporte",
    learningHub: "🎮 Centro de Aprendizaje",
    signOut: "Cerrar Sesión",
    signedOut: "Sesión cerrada",
    signedOutDesc: "Has cerrado sesión correctamente",
    errorSigningOut: "Error al cerrar sesión",
    parcelPassport: "Pasaporte Digital",
    epidemiologicalRisk: "Riesgo Epidemiológico",
    machineryImport: "Importar Datos Maquinaria",
    golfCourse: "Gestión Campo de Golf",
    vraShapefileBuilder: "Constructor VRA Shapefile",
    aiCropClassification: "Clasificación IA de Cultivos",
    agBusinessMultiAdvisor: "AgBusiness (Multi-Asesor)",
    firePropagation: "Propagación de Incendios",
    multiFarmOverview: "Vista Multi-Finca",
    parcels: "Parcelas",
    analytics: "Analíticas",
    satellite: "Satélite",
    settings: "Ajustes",
    insuranceDashboard: "Panel de Seguros",
    greenSpaces: "Espacios Verdes"
    ,
    weatherConditions: "Clima y Condiciones",
    economicRiskImpact: "Impacto económico del riesgo",
    harvestValueEstimator: "Estimador de valor de cosecha",
    pacPreCompliance: "Revisión de cumplimiento",
    digitalParcelRecord: "Registro digital de parcela",
    settingsGroup: "Ajustes",
    helpSupport: "Ayuda y soporte",
    adminTools: "Herramientas de administración",
    droughtWaterStress: "Sequía y estrés hídrico",
    floodRisk: "Riesgo de inundación",
    pestDiseaseRisk: "Riesgo de plagas y enfermedades",
    epidemiologicalRisk2: "Mapa de riesgo epidemiológico",
    agronomicRiskAssessment: "Evaluación de riesgo agronómico",
    vraExports: "Constructor Yield-to-VRA",
    verifiedFarmBeta: "Finca verificada",
    integrations: "Integraciones",
    groupDashboard: "Dashboard",
    groupParcel: "Parcela",
    groupMonitor: "Monitorizar",
    groupRisk: "Riesgo",
    groupDecide: "Decidir",
    groupReport: "Reportar",
    groupProve: "Demostrar",
    foliarAnalysis: "Análisis foliar",
    agronomyTools: "Herramientas agronómicas"
  },
  multiFarm: {
    title: "Vista Multi-Finca",
    subtitle: "Monitorea todas tus parcelas de un vistazo — diseñado para técnicos que gestionan múltiples explotaciones",
    refresh: "Actualizar",
    totalParcels: "Total Parcelas",
    avgNdvi: "NDVI Prom.",
    highRisk: "Riesgo Alto",
    activeAlerts: "Alertas Activas",
    allClear: "Todo bien",
    needsAttention: "Requieren atención",
    unread: "Sin leer",
    searchPlaceholder: "Buscar por nombre o cultivo...",
    sortRisk: "Riesgo",
    sortArea: "Superficie",
    noParcels: "No se encontraron parcelas",
    noResults: "Ninguna parcela coincide con tu búsqueda",
    addParcelsFirst: "Añade parcelas en la sección de Gestión para comenzar",
    colParcel: "Parcela",
    colCrop: "Cultivo",
    colArea: "Superficie",
    colRisk: "Riesgo",
    colAlerts: "Alertas",
    colTemp: "Temp",
    colWater: "Agua",
    colAction: "Acción",
    view: "Ver",
    excellent: "Excelente",
    good: "Bueno",
    fair: "Regular",
    poor: "Pobre",
    critical: "Crítico",
    high: "Alto",
    medium: "Medio",
    low: "Bajo",
    unnamedParcel: "Parcela sin nombre",
    footerInfo: "Datos del último análisis satelital y proveedores meteorológicos. Haz clic en cualquier fila para ver detalles."
  },
  auth: {
    signIn: "Iniciar Sesión",
    signUp: "Registrarse",
    email: "Correo Electrónico",
    password: "Contraseña",
    confirmPassword: "Confirmar Contraseña",
    forgotPassword: "¿Olvidaste tu Contraseña?",
    rememberMe: "Recordarme",
    noAccount: "¿No tienes cuenta?",
    hasAccount: "¿Ya tienes cuenta?",
    createAccount: "Crear Cuenta",
    resetPassword: "Restablecer Contraseña",
    sendResetLink: "Enviar Enlace de Restablecimiento",
    firstName: "Nombre",
    lastName: "Apellido",
    phone: "Número de Teléfono",
    farmName: "Nombre de la Granja",
    termsAgree: "Acepto los Términos de Servicio y la Política de Privacidad"
  },
  settings: {
    title: "Configuración",
    subtitle: "Gestiona tu cuenta y preferencias",
    profile: "Perfil",
    notifications: "Notificaciones",
    preferences: "Preferencias",
    security: "Seguridad",
    billing: "Facturación",
    language: "Idioma",
    timezone: "Zona Horaria",
    units: "Unidades",
    metric: "Métrico",
    imperial: "Imperial",
    emailNotifications: "Notificaciones por Email",
    smsNotifications: "Notificaciones SMS",
    pushNotifications: "Notificaciones Push",
    saveChanges: "Guardar Cambios",
    changePassword: "Cambiar Contraseña",
    twoFactor: "Autenticación de Dos Factores",
    deleteAccount: "Eliminar Cuenta"
  },
  footer: {
    company: "Empresa",
    aboutUs: "Sobre Nosotros",
    careers: "Carreras",
    press: "Prensa",
    blog: "Blog",
    product: "Producto",
    features: "Características",
    pricing: "Precios",
    integrations: "Integraciones",
    api: "API",
    support: "Soporte",
    helpCenter: "Centro de Ayuda",
    documentation: "Documentación",
    contactUs: "Contáctanos",
    status: "Estado",
    legal: "Legal",
    privacy: "Política de Privacidad",
    terms: "Términos de Servicio",
    cookies: "Política de Cookies",
    copyright: "© 2026 Sentinel Crop. Sentinel Crop® es una marca registrada de Astranova Consultoría Avanzada S.L.U. Todos los derechos reservados."
  }
};
